import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { REMOVE_SELECTED_USER } from "../../store/reducers/selectedUserSlice";
import { toast } from "react-toastify";
import ModifyUserModal from "../user/modals/ModifyUserModal";
import { useState } from "react";
import { User } from "../../models/user.model";
import { Template } from "../../models/templates.model";
import React from "react";

type UserContractConnectionManagerProps = {
    template: Template | undefined;
    color: string;
    title: string;
    user: User | undefined;
}

export default function UserContractConnectionManager ({ template, color , title, user} : UserContractConnectionManagerProps) {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [stateChange, setStateChange] = useState<boolean>(false)
    const [showModifyModal, setShowModifyModal] = useState<boolean>(false)

    const openModal = () => setShowModifyModal(true);
    const closeModal = () => setShowModifyModal(false);

    const handleStateChange = () => {
        setStateChange(!stateChange)
    }

    React.useEffect(() => {

    }, [user])

    return (
        <>
        <ModifyUserModal title="adatai" user={user} showModal={showModifyModal} closeModal={closeModal} handleStateChange={handleStateChange}/>
        
        {template && (
            <div className="mb-3 w-fit items-center text-sm font-medium rounded-lg sm:flex h-8 mt-5">
                <button 
                onClick={() => navigate('/manager', { state: { template } })}
                className={`hover:text-cream text-white bg-${color} font-bold uppercase text-sm px-3 py-1 mt-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1`}>{title}</button>
            {/* Ha van kiválasztott user */}
            {user && (
                <>
                    <button 
                    onClick={() => {
                        openModal()
                    }}
                    className={`hover:text-cream text-white bg-${color} font-bold uppercase text-sm px-3 py-1 mt-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1`}>Ügyféladatok megtekintése</button>
                
                    <button 
                    onClick={() => {
                        dispatch(REMOVE_SELECTED_USER())
                        toast.success('Felhasználó eltávolítva a szerződésről!')
                    }}
                    className={`hover:text-cream text-white bg-error font-bold uppercase text-sm px-3 py-1 mt-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1`}>Ügyféladatok törlése</button>
                </>
            )}
            </div>
        )}
        </>
    )
}